var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOhsLogoIconGradient1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 450.15 482.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient-14);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-6);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-11);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-10);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#linear-gradient-7);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#linear-gradient-9);\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: url(#linear-gradient-8);\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: url(#linear-gradient-12);\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: url(#linear-gradient-13);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -175.81,
    y1: 322.2,
    x2: 703.02,
    y2: 322.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#15b3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#660094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ed2836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feff2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -175.81,
    y1: 394.15,
    x2: 703.02,
    y2: 394.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -175.81,
    y1: 362.49,
    x2: 703.02,
    y2: 362.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -175.81,
    y1: 277.69,
    x2: 703.02,
    y2: 277.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -175.81,
    y1: 193.11,
    x2: 703.02,
    y2: 193.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -175.81,
    y1: 128.76,
    x2: 703.02,
    y2: 128.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -175.81,
    y1: 192.53,
    x2: 703.02,
    y2: 192.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -175.81,
    y1: 182.55,
    x2: 703.02,
    y2: 182.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -175.81,
    y1: 216.45,
    x2: 703.02,
    y2: 216.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -175.81,
    y1: 340,
    x2: 703.02,
    y2: 340,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -175.81,
    y1: 193.78,
    x2: 703.02,
    y2: 193.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -175.81,
    y1: 303.51,
    x2: 703.02,
    y2: 303.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -175.81,
    y1: 362.49,
    x2: 703.02,
    y2: 362.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -175.81,
    y1: 319.81,
    x2: 703.02,
    y2: 319.81,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M431.7,309.83l-2.28,1.29-43.42,25.07-3.62,2.1c.23-4.92,1.53-9.55,3.62-13.66,5.62-11,17.05-18.53,30.25-18.53,4.68,0,9.13,.93,13.17,2.66,.78,.31,1.53,.67,2.28,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M416.26,306.1c4.68,0,9.13,.93,13.17,2.66v52.89l-20,11.54-188.79,108.99-121.87-70.35v-50.12l43.42,25.05,48.28,27.89,30.17,17.41,13.25-7.66,148.47-85.7h.03l3.62-2.12v-11.95c5.62-11,17.05-18.53,30.25-18.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M56.69,337.41c6.83,6.18,11.1,15.14,11.1,25.07s-4.27,18.86-11.07,25.07c-.44,.41-.91,.8-1.37,1.19v-52.53c.44,.39,.91,.78,1.32,1.16t.03,.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "142.19 160.14 142.19 395.25 98.77 395.25 98.77 183.9 142.19 160.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M98.77,182.55v21.11c-4.61-5.8-7.37-13.12-7.37-21.11h7.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "349.95 177.22 155.79 55.26 132.69 92.02 308.2 202.27 349.95 177.22"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 324.43,
    cy: 192.53,
    r: 33.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M159.19,182.55c0,12.58-6.83,23.55-17,29.37-4.97,2.87-10.74,4.53-16.9,4.53-10.74,0-20.31-4.99-26.52-12.78-4.61-5.8-7.37-13.12-7.37-21.11,0-18.71,15.19-33.9,33.9-33.9s33.9,15.19,33.9,33.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 212.18,
    cy: 216.45,
    r: 33.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M450.15,340c0,18.71-15.19,33.9-33.9,33.9-2.33,0-4.63-.23-6.83-.7-15.47-3.16-27.09-16.82-27.09-33.2,0-.44,0-.88,.03-1.29h.03c-.03-.16-.03-.28,0-.41,.23-4.92,1.53-9.55,3.62-13.66,5.62-11,17.05-18.53,30.25-18.53,4.68,0,9.13,.93,13.17,2.66,.78,.31,1.53,.67,2.28,1.06,10.95,5.61,18.45,17,18.45,30.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M429.43,120.55v140.45l-43.42,25.05V145.63L220.64,50.15l-38.01,21.94-42.54,24.58-84.82,48.96v190.96l.08,.05,1.32,.75s.03,0,.03,.03c6.83,6.18,11.1,15.14,11.1,25.07s-4.27,18.86-11.07,25.07l-1.37-.8-43.5-25.1V120.55L220.64,0l208.79,120.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "233.72 373.89 412.38 270.74 390.67 233.14 190.47 348.72 233.72 373.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M67.79,362.49c0,9.94-4.27,18.86-11.07,25.07-.44,.41-.91,.8-1.37,1.19-5.85,4.76-13.33,7.63-21.45,7.63-18.71,0-33.9-15.16-33.9-33.9,0-10.3,4.61-19.51,11.85-25.72,5.93-5.1,13.64-8.18,22.05-8.18s15.53,2.85,21.37,7.58c.03,.03,.05,.05,.08,.05,.44,.39,.91,.78,1.32,1.16t.03,.03c6.83,6.18,11.1,15.14,11.1,25.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "190.47 226.01 190.47 437.36 233.89 437.36 233.89 202.27 190.47 226.01 190.47 226.01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOhsLogoIconGradient1);
export default __webpack_public_path__ + "static/media/ohs_logo_icon_gradient1.e55ea0f89423f5762fe2db3d2eb69752.svg";
export { ForwardRef as ReactComponent };